import permisosPersona, { RESOURCE_PERSONA } from '@/auth/permissions/modules/personaPg'
import { defineMenu } from '@/utils/menu'
import { ROUTE_INFORME_CCONT_PROVEEDOR_ESTAB } from '@routes/persona-pg/nombres/informes'

const { informes } = permisosPersona
export default defineMenu([
    {
        title: 'persona.subopciones.proveedor_por_establecimiento',
        route: ROUTE_INFORME_CCONT_PROVEEDOR_ESTAB,
        resource: RESOURCE_PERSONA,
        action: informes.informeProveedorPorCuenta,
    },
])
